import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx="13.318" cy="14.126" r="13.25" fill="currentColor" /><path className={styles["tick"] || "tick"} d="M7.318 14.364l4.084 4.083 8.166-8.167" stroke="#fff" strokeWidth="2" /></svg>);